import React from 'react'
import Freelance from './Freelance'
import Info from './Info'
import FormSection from './FormSection'
import GoToTop from '../Helpers/GoToTop'


const Contact = () => {
    return (
        <>
            <Freelance />
            <Info />
            <FormSection />
            <GoToTop />
        </>
    )
}

export default Contact